import apiClient from "./apiClient";
import { DeleteRequest } from "@/types/deleteRequest";
import {
  CalculationReportResponse,
  Generate1CReportAsyncRequest,
  GenerateReportForMIOAsyncRequest,
  GenerateReportForMonitoringAsyncRequest, Kindergarten1cActReconciliation,
  KindergartenCalculationReport,
  KindergartenCalculationSearchParam,
  RejectCalculationReportRequest,
  Report
} from "@/types/report";
import {PageResponse} from "@/types/pageResponse";
import {SearchParam} from "@/types/searchParam";
import Kindergarten1cActReconciliationView from "@/views/Kindergarten1cActReconciliationView.vue";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const BASE_URL_REPORT = `${BASE_URL}/api/v1/report`;
const GENERATE_SUMMARY_REPORT_URL = `${BASE_URL_REPORT}/summary`;
const GENERATE_1C_REPORT_URL = `${BASE_URL_REPORT}/1c`;
const GENERATE_REPORT_FOR_MIO_URL = `${BASE_URL_REPORT}/report-for-mio`;
const GENERATE_REPORT_FOR_MONITORING_URL = `${BASE_URL_REPORT}/report-for-monitoring`;
const GET_GENERATED_REPORT_LIST_URL = `${BASE_URL_REPORT}/calculation/list/report`;
const GET_GENERATED_TIMESHEET_LIST_URL = `${BASE_URL_REPORT}/timesheet/list/report`;
const GET_GENERATED_DIRECTORY_LIST_URL = `${BASE_URL_REPORT}/kindergarten/directory/list/report`;
const GET_GENERATED_TIMESHEET_GENERAL_LIST_URL = `${BASE_URL_REPORT}/timesheet/general/list/report`;
const GET_GENERATED_PRE_CALCULATION_TIMESHEET_LIST_URL = `${BASE_URL_REPORT}/timesheet/list/pre-calculation/report`;
const GET_REPORT_LIST_URL = `${BASE_URL_REPORT}/list`;
const DOWNLOAD_REPORT_URL = `${BASE_URL_REPORT}/download`;
const DOWNLOAD_REPORT_BYTES_URL = `${BASE_URL_REPORT}/download/bytes`;
const GET_KINDERGARTEN_CALCULATION_REPORT_LIST_URL = `${BASE_URL_REPORT}/calculation/list`;
const GET_KINDERGARTEN_CALCULATION_REPORT_LIST_FOR_HEAD_URL = `${BASE_URL_REPORT}/calculation/head`;
const GET_ALL_KINDERGARTEN_CALCULATION_REPORT_URL = `${BASE_URL_REPORT}/calculation/list`;
const REJECT_KINDERGARTEN_CALCULATION_REPORT_URL = `${BASE_URL_REPORT}/calculation/reject`;
const GENERATE_CALCULATION_REPORT_LIST_URL = `${BASE_URL_REPORT}/generate/calculation/list`;

export async function generateSummaryReport(
  searchParam: SearchParam,
) {
  try {
    return await apiClient.post(
        GENERATE_SUMMARY_REPORT_URL, searchParam
    );
  } catch (error) {
    console.error("Error fetching directory list:", error);
    throw error;
  }
}

export async function generate1CReport(
    params: Generate1CReportAsyncRequest
) {
  try {
    const url = `${GENERATE_1C_REPORT_URL}`;
    const response = await apiClient.post(
        url, params,
        {
          responseType: 'blob',
        }
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = `report-1c_${params.accountingMonth}.${params.accountingYear}.xlsx`;

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  } catch (error) {
    console.error("Error generating 1c report:", error);
    throw error;
  }
}

export async function generateReportForMIO(
    params: GenerateReportForMIOAsyncRequest
) {
  try {
    const url = `${GENERATE_REPORT_FOR_MIO_URL}`;
    const response = await apiClient.post(
        url, params,
        {
          responseType: 'blob',
        }
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = `report-for-mio_${params.startAccountingMonth}_${params.endAccountingMonth}.${params.accountingYear}.xlsx`;

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  } catch (error) {
    console.error("Error generating 1c report:", error);
    throw error;
  }
}

export async function generateReportForMonitoring(
    params: GenerateReportForMonitoringAsyncRequest
) {
  try {
    const url = `${GENERATE_REPORT_FOR_MONITORING_URL}`;
    const response = await apiClient.post(
        url, params,
        {
          responseType: 'blob',
        }
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = `report-for-monitoring_${params.accountingMonth}_${params.accountingYear}.xlsx`;

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  } catch (error) {
    console.error("Error generating 1c report:", error);
    throw error;
  }
}

export async function getGeneratedCalculationReportList(
    params: KindergartenCalculationSearchParam
) {
  try {
    const response = await apiClient.post(
        GET_GENERATED_REPORT_LIST_URL, params, {
          responseType: 'blob',
        }
    );
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = `tmp.xlsx`;

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  } catch (error) {
    console.error("Error generating 1c report:", error);
    throw error;
  }
}


export async function getGeneratedTimesheetList(
    params: SearchParam
) {
  try {
    const response = await apiClient.post(
        GET_GENERATED_TIMESHEET_LIST_URL, params, {
          responseType: 'blob',
        }
    );
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = `timesheet.xlsx`;

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  } catch (error) {
    console.error("Error generating 1c report:", error);
    throw error;
  }
}

export async function getGeneratedTimesheetGeneralList(
    params: SearchParam
) {
  try {
    const response = await apiClient.post(
        GET_GENERATED_TIMESHEET_GENERAL_LIST_URL, params, {
          responseType: 'blob',
        }
    );
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = `timesheet.xlsx`;

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  } catch (error) {
    console.error("Error generating 1c report:", error);
    throw error;
  }
}


export async function getGeneratedPreCalculationTimesheetList(
    params: SearchParam
) {
  try {
    const response = await apiClient.post(
        GET_GENERATED_PRE_CALCULATION_TIMESHEET_LIST_URL, params, {
          responseType: 'blob',
        }
    );
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = `pre-calculation-timesheet.xlsx`;

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  } catch (error) {
    console.error("Error generating 1c report:", error);
    throw error;
  }
}

export async function getGeneratedFactPaymentReport(
    params: SearchParam
) {
  try {
    const response = await apiClient.post(
        `${BASE_URL_REPORT}/paid-amount`, params, {
          responseType: 'blob',
        }
    );
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = `fact-payment.xlsx`;

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  } catch (error) {
    console.error("Error generating 1c report:", error);
    throw error;
  }
}

export async function getKindergartenAnalyticsReport(searchParam: SearchParam) {
  try {
    const response = await apiClient.post(
        `${BASE_URL_REPORT}/analytics`,
        searchParam,
        {
          responseType: 'blob',
        }
    );
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = `kindergarten-analytics-report.xlsx`;

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  } catch (error) {
    console.error("Error generating 1c report:", error);
    throw error;
  }
}


export async function generateCalculationReport(
  token: string,
  data: CalculationReportResponse
) {
  try {
    return await apiClient.post(
        GENERATE_CALCULATION_REPORT_LIST_URL,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    )
  } catch (error) {
    console.error("Error fetching directory list:", error);
    throw error;
  }
}

export async function getReportList(
  params: SearchParam
): Promise<PageResponse<Report>> {
  try {
    const response = await apiClient.post<PageResponse<Report>>(
      GET_REPORT_LIST_URL, params
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching directory list:", error);
    throw error;
  }
}

export async function downloadReportFile(
  token: string,
  fileId: string,
  fileName: string
) {
  try {
    const response = await apiClient.get(
      `${DOWNLOAD_REPORT_URL}/${fileId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      }
    )

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  } catch (error) {
    console.error("Error download file: ", error);
    throw error;
  }
}

export async function kindergartenCalculationReportList(
  token: string,
  lmsId: string
): Promise<KindergartenCalculationReport[]> {
  try {
    const response = await apiClient.get<KindergartenCalculationReport[]>(
      `${GET_KINDERGARTEN_CALCULATION_REPORT_LIST_URL}/${lmsId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error download file: ", error);
    throw error;
  }
}

export async function kindergarten1cActReconciliationReportList(searchParam: SearchParam | null): Promise<PageResponse<Kindergarten1cActReconciliation>> {
  try {
    const response = await apiClient.post<PageResponse<Kindergarten1cActReconciliation>>(
        `${BASE_URL}/api/v1/1c/act-reconciliation/list`, searchParam
    )
    return response.data;
  } catch (error) {
    console.error("Error fetching kindergartenCalculationListForHead:", error);
    throw error;
  }
}

export async function setSaveAccountantAccept(id: number): Promise<Kindergarten1cActReconciliation> {
  try {
    const response = await apiClient.post<Kindergarten1cActReconciliation>(
        `${BASE_URL}/api/v1/1c/act-reconciliation/accountant/accept/${id}`
    )
    return response.data;
  } catch (error) {
    console.error("Error fetching kindergartenCalculationListForHead:", error);
    throw error;
  }
}

export async function kindergartenCalculationListForHead(
    token: string,
    page: number,
    size: number
): Promise<PageResponse<KindergartenCalculationReport>> {
  try {
    const response = await apiClient.get<PageResponse<KindergartenCalculationReport>> (
        `${GET_KINDERGARTEN_CALCULATION_REPORT_LIST_FOR_HEAD_URL}?page=${page}&size=${size}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching kindergartenCalculationListForHead:", error);
    throw error;
  }
}

export async function downloadFileBytes(
    token: string,
    fileId: string
): Promise<any> {
  try {
    const response = await apiClient.get<any>(
        `${DOWNLOAD_REPORT_BYTES_URL}/${fileId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob' as 'json'
        }
    )
    return response.data;
  } catch (error) {
    console.error("Error on download:", error);
    throw error;
  }
}

export async function getAllKindergartenCalculation(
    params: KindergartenCalculationSearchParam
): Promise<PageResponse<KindergartenCalculationReport>> {
  try {
    const response = await apiClient.post<PageResponse<KindergartenCalculationReport>>(
        `${GET_ALL_KINDERGARTEN_CALCULATION_REPORT_URL}`,
        params
    );
    return response.data;
  } catch (error) {
    console.error("Error getting KindergartenCalculation:", error);
    throw error;
  }
}

export async function rejectKindergartenCalculationReport(
    token: string,
    params: RejectCalculationReportRequest
) {
  try {
    return await apiClient.post(
        REJECT_KINDERGARTEN_CALCULATION_REPORT_URL,
        params,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
    );
  } catch (error) {
    console.error("Error rejecting kindergarten calculation report", error);
    throw error;
  }
}

export async function generateCalculationReportList(params: CalculationReportResponse) {
  try {
    const response = await apiClient.post(GENERATE_CALCULATION_REPORT_LIST_URL, params);
    return response.data;
  } catch (error) {
    console.error("error on start generating calculation reports", error);
    throw error;
  }
}

export async function restoreSelectedKindergartenCalculations(kindergartenCalculationIds: number[], reason: string) {
  const response = await apiClient.post(
      `${BASE_URL_REPORT}/calculation/restore`,
      { ids: kindergartenCalculationIds, reason } as DeleteRequest<number>
  );
  return response.status;
}

export async function deleteSelectedKindergartenCalculations(kindergartenCalculationIds: number[], reason: string) {
  try {
    const response = await apiClient.post(
        `${BASE_URL_REPORT}/calculation/delete`,
        { ids: kindergartenCalculationIds, reason } as DeleteRequest<number>
    )
    return response.status;
  } catch (error) {
    console.log("error on deleting calculation reports", error);
    throw error;
  }
}

export async function getGeneratedKindergartenDirectoryList(
    params: object
) {
  try {
    const response = await apiClient.post(
        GET_GENERATED_DIRECTORY_LIST_URL, params, {
          responseType: 'blob',
        }
    );
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = `kindergarten_directory.xlsx`;

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  } catch (error) {
    console.error("Error generating kindergarten directory report:", error);
    throw error;
  }
}

export async function downloadKindergartenSpecialStandardReport(): Promise<any> {
  try {
    const response = await apiClient.post(
        `${BASE_URL_REPORT}/special/standard`, {}, {
          responseType: 'blob' as 'json'
        }
    );
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = `kindergarten-special-standard.xlsx`;

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  } catch (error) {
    console.error("Error generating 1c report:", error);
    throw error;
  }
}